import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`From Cloud Manager, you can find your tenant ID in the instance detailLs for your Commerce Optimizer project.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in to your `}<a parentName="p" {...{
            "href": "https://experience.adobe.com/"
          }}>{`Adobe Experience Cloud`}</a>{` account.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under `}<strong parentName="p">{`Quick access`}</strong>{`, click `}<strong parentName="p">{`Commerce`}</strong>{` to open the Commerce Cloud Manager.`}</p>
        <p parentName="li">{`The Commerce Cloud Manager displays a list of instances that are available in your Adobe IMS organization.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To get the tenant ID, click the information icon next to the Adobe Commerce Optimizer instance name.`}</p>
        <p parentName="li"><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1280px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.68750000000001%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block",
                "transition": "opacity 0.5s 0.5s",
                "pointerEvents": "none"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/5530d/aco-instance-details.webp 320w", "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/0c8fb/aco-instance-details.webp 640w", "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/94b1e/aco-instance-details.webp 1280w", "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/aee86/aco-instance-details.webp 1328w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/dd4a7/aco-instance-details.png 320w", "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/0f09e/aco-instance-details.png 640w", "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/bbbf7/aco-instance-details.png 1280w", "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/853dd/aco-instance-details.png 1328w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/commerce/services/static/523416dc66c75cabc2270ed7fcda958d/bbbf7/aco-instance-details.png",
                "alt": "Access URLs for Commerce Optimizer UI, REST, and GraphQL APIs",
                "title": "Access URLs for Commerce Optimizer UI, REST, and GraphQL APIs",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "opacity": "0",
                  "transition": "opacity 0.5s",
                  "color": "inherit",
                  "boxShadow": "inset 0px 0px 0px 400px none",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <p parentName="li">{`The instance details page opens, displaying the tenant ID and other instance information. The tenant ID is displayed in the `}<inlineCode parentName="p">{`Instance ID`}</inlineCode>{` field.`}</p>
      </li>
    </ol>
    <p>{`You can also find the tenant ID from the access URL for the Adobe Commerce Optimizer application interface, the value is in the path, for example `}<inlineCode parentName="p">{`/in:XDevkG9W6UbwgQmPn995r3/`}</inlineCode>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`If you don't have access to the Commerce Cloud Manager, contact your system administrator.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      